import React from 'react'
import PropTypes from 'prop-types'
import { DATE_FORMAT } from 'utils/constants'
import moment from 'moment'

import { DatePicker as AntdDatePicker } from 'antd'

const DatePicker = ({
  value,
  onChange,
  allowClear,
  placeholder,
  suffixIcon,
  style,
}) => {
  const handleOnChange = (date, dateString) => {
    onChange(date, dateString)
  }

  return (
    <AntdDatePicker
      value={value != null ? moment(value) : null}
      onChange={handleOnChange}
      format={DATE_FORMAT}
      showToday
      allowClear={allowClear}
      {...(placeholder !== undefined && { placeholder })}
      {...(suffixIcon !== undefined && { suffixIcon })}
      {...(style !== undefined && { style })}
    />
  )
}

DatePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  allowClear: PropTypes.bool,
  placeholder: PropTypes.string,
  suffixIcon: PropTypes.node,
  style: PropTypes.object,
}

export default DatePicker
